// src/features/executive/sales/hooks/use-top-products.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import SalesApi from 'api/executive/sales.api'
import type {
  GetTopProductsParams,
  TopProductsResponse,
  ExecutiveFilterState,
} from 'api/executive/executive.types'

export function useTopProducts(scopedFilters?: Partial<ExecutiveFilterState>) {
  return useExecutiveQuery<GetTopProductsParams, TopProductsResponse>(
    'sales.top-products',
    SalesApi.getTopProducts,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        limit: 5,
      }
    },
    { scopedFilters }
  )
}
